import { render, staticRenderFns } from "./VaimoGrid.vue?vue&type=template&id=5b101f02&scoped=true&"
import script from "./VaimoGrid.vue?vue&type=script&lang=ts&"
export * from "./VaimoGrid.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoGrid.vue?vue&type=style&index=0&id=5b101f02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b101f02",
  null
  
)

export default component.exports